import { EmptyState } from '@buffer-mono/popcorn'

import { BanIcon } from '~publish/pages/Community/shared/BanIcon'

import type { JSX } from 'react'

export function UnsupportedPostEmptyState(): JSX.Element {
  return (
    <EmptyState size="large" variant="neutral">
      <EmptyState.Icon>
        <BanIcon size={32} />
      </EmptyState.Icon>
      <EmptyState.Heading>
        Comments not available for this post
      </EmptyState.Heading>
      <EmptyState.Description>
        Some posts, like reminders, stories, or updates, don&apos;t receive
        comments in Community. Select another post to keep engaging with your
        audience.
      </EmptyState.Description>
    </EmptyState>
  )
}
